class BeforeAndAfterSlider extends HTMLElement {
  constructor() {
    super();

    const foregroundImageWrapper = this.querySelector('[data-foreground-image]');
    const revealInput = this.querySelector('[data-reveal-input]');
    const revealButton = this.querySelector('[data-reveal-button]');

    // Update the width of the foreground image & the position of the slider button on input change
    revealInput.addEventListener('input', () => {
      foregroundImageWrapper.style.width = revealInput.value + '%';
      revealButton.style.left = revealInput.value + '%';
    });
  }
}

if (!customElements.get('before-and-after-slider')) {
  customElements.define('before-and-after-slider', BeforeAndAfterSlider);
}
